import { useQuery } from '@tanstack/react-query';

import { ALL_MODULES_PAGE_SIZE } from '@/modules/players/v2/tabs/constants';
import { LeaguesStatus } from '@/types/leagues.types';
import { PlayerParticipationType } from '@/types/players.types';
import { getPlayerLeagues } from '@/utils/actions/players/non-edit/getPlayerLeagues';

const PLAYER_LEAGUES_QUERY_KEY = 'player-leagues';

interface usePlayerLeaguesArgs {
  playerId: string;
  activeLeagueType: PlayerParticipationType;
  status: LeaguesStatus;
  searchParams: {
    [key: string]: string;
  };
}

export const usePlayerLeagues = ({
  playerId,
  activeLeagueType,
  status,
  searchParams,
}: usePlayerLeaguesArgs) => {
  return useQuery({
    queryKey: [PLAYER_LEAGUES_QUERY_KEY, playerId, activeLeagueType, status, searchParams],

    queryFn: async () =>
      getPlayerLeagues({
        id: playerId,
        type: activeLeagueType,
        activity: status,
        pageSize: ALL_MODULES_PAGE_SIZE.toString(),
        currentPage: searchParams.page,
        searchWord: searchParams.search,
      }),

    keepPreviousData: true,
  });
};
